<markant-platform-guided-tour-wrapper
  [guidedTourSteps]="generalInformationSteps"
  [onNext]="nextButtonCallback"
  [onBack]="backButtonCallback"
  [currentStep]="currentStep"
  [enableClickThrough]="currentStep !== 3"
></markant-platform-guided-tour-wrapper>

@if (showStartDialog) {
  <markant-platform-section-start-dialog
    id="oa-admin-area-general-information-start-dialog"
    [tourTranslationKey]="guidedTour.id"
    [sectionNumber]="sectionNumber"
    (tourStart)="nextTarget()"
    (cancel)="cancelSection()"
  ></markant-platform-section-start-dialog>
}

<div
  *ngIf="currentStep === 3"
  class="click-overlay"
  (click)="nextTarget()"
></div>
